import type { ErrorMessages } from '../errors';
import { monthYear } from '../format';

const month = (value: unknown) =>
  typeof value === 'string' ? monthYear(value) : '';

/** arqam's billing-configuration codes (docs/changes/34 there), in Arabic. */
export const PRICING_ERRORS: ErrorMessages = {
  NAME_REQUIRED: 'اكتب اسم التسعيرة.',
  BILLING_METHOD_REQUIRED: 'اختر طريقة الحساب.',
  TIERS_REQUIRED: 'أضف شريحة واحدة على الأقل.',
  TIER_INCOMPLETE: 'أكمل كل الشرائح (النهاية والسعر).',
  TIER_FIRST_START: 'الشريحة الأولى تبدأ من 1 م³.',
  TIERS_NOT_CONTIGUOUS: ({ expected }) =>
    `الشرائح يجب أن تتتابع: الشريحة الموالية تبدأ من ${expected} م³.`,
  TIER_END_BEFORE_START: ({ tierStart }) =>
    `نهاية الشريحة التي تبدأ من ${tierStart} م³ أصغر من بدايتها.`,
  TIER_OPEN_BEFORE_LAST: 'الشريحة الأخيرة وحدها تكون بلا نهاية.',
  LAST_TIER_NOT_OPEN: 'الشريحة الأخيرة يجب أن تكون بلا نهاية.',
  TIER_OUT_OF_RANGE: 'حدود الشرائح كبيرة جداً.',
  RATE_NEGATIVE: 'السعر لا يكون سالباً.',
  FIXED_REQUIRES_ONE_TIER: 'السعر الموحد له سعر واحد.',
  FEE_NAME_REQUIRED: 'اكتب اسم كل رسم.',
  FEE_NAME_DUPLICATE: ({ name }) => `اسم الرسم «${name}» مكرر.`,
  FEE_INCOMPLETE: 'أكمل كل الرسوم (النوع والمبلغ).',
  FEE_AMOUNT_NEGATIVE: 'مبلغ الرسم لا يكون سالباً.',
  FEE_PERCENTAGE_OVER_100: 'النسبة لا تتجاوز 100%.',
  EFFECTIVE_FROM_REQUIRED: 'اختر شهر البداية.',
  EFFECTIVE_FROM_NOT_MONTH_START: 'تبدأ التسعيرة في أول الشهر.',
  EFFECTIVE_FROM_NOT_AFTER_BILLS: ({ lastBilledMonth }) =>
    `صدرت فواتير ${month(lastBilledMonth)}: اختر شهراً بعده (لا تتغير أسعار شهر صدرت فواتيره).`,
  EFFECTIVE_FROM_NOT_AFTER_LATEST: ({ latestEffectiveFrom }) =>
    `توجد تسعيرة تبدأ في ${month(latestEffectiveFrom)}: اختر شهراً بعده، أو احذف تلك التسعيرة أولاً.`,
  CONFIG_IN_USE:
    'هذه التسعيرة مستعملة في فواتير: أسعارها مقفلة ولا يمكن حذفها.',
  SHART_UNIT_PRICE_INVALID: 'ثمن الشرط لا يمكن أن يكون سالباً',
  CONFIG_NOT_LATEST: 'لا تُحذف إلا آخر تسعيرة.',
  BILLING_CONFIGURATION_NOT_FOUND: 'هذه التسعيرة لم تعد موجودة.',
};
